import { CurrencyNgn } from "@phosphor-icons/react";
import { FieldProps } from "formik";
import React from "react";

interface CurrencyInputProps extends FieldProps {
  placeholder?: string;
  icon?: React.ReactNode;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  field,
  form,
  placeholder,
  icon,
}) => {
  // Format the number with commas
  const formatNumber = (value: string | number) => {
    const num = Number(value);
    if (isNaN(num)) return "";
    return num.toLocaleString();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/,/g, "");
    if (!isNaN(Number(rawValue))) {
      // Store the raw number in Formik
      form.setFieldValue(field.name, Number(rawValue));
    }
  };

  const displayValue = field.value ? formatNumber(field.value) : "";

  return (
    <div className="rounded-lg border border-gray-300 shadow px-4 flex items-center gap-2 w-full focus-within:outline-deepBlue focus-within:outline">
      {icon ? icon : <CurrencyNgn />}
      <input
        {...field}
        placeholder={placeholder || "Amount"}
        className="flex py-3 focus:outline-none flex-1"
        inputMode="numeric"
        onChange={handleChange}
        value={displayValue}
      />
    </div>
  );
};

export default CurrencyInput;
